<template>
  <div class="regist-success">
    <img src="@/assets/img/dq/reg_success.png" />
    <p>您已成功完成发票签收</p>
  </div>
</template>

<script>
export default {
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.regist-success {
  line-height: 1;
  font-family: PingFangSC-Medium, PingFang SC;
}
img {
  margin-top: 60px;
  width: 54px;
  height: 54px;
}
p {
  font-size: 21px;
  font-weight: 500;
  color: #111111;
}
</style>